import { buildCompactStatementRow } from './sharedRowFields';

export const adaptReceivableStatement = (statement, transaction) => {
    const resolvedTransaction = transaction || statement.Transaction;

    // HasCommission arriva da buildCompactStatementRow: true solo sulla fee principale (non su commissione o advance)
    return buildCompactStatementRow({
        statement,
        transaction: resolvedTransaction,
        extra: {
            ClientName: statement.ClientName ?? resolvedTransaction?.ClientName,
            TransactionPerc: statement.TransactionPerc,
            IsCommission: statement.IsCommission ?? statement.isCommission,
            IsClientAdvance: statement.IsClientAdvance ?? statement.isClientAdvance,
        },
    });
};

export const adaptReceivableStatements = (transactions = []) => {
    return transactions.flatMap((transaction) =>
        transaction.Statements.map((statement) => adaptReceivableStatement(statement, transaction))
    );
};
